/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".image_4aa51e4d{display:block}\n"}]);
export const image = "image_4aa51e4d";